import { getUrlParam } from '@core/utils'
import api from '@api/annualMerchant'
let cinfo = {
  cid: '',
  cname: ''
}
export const getLocation = () => {
  return new Promise((resolve, reject) => {
    if (getUrlParam('cid')) {
      cinfo.cid = getUrlParam('cid')
      resolve(cinfo)
    } else if (sessionStorage.getItem('location_info')) {
      cinfo = JSON.parse(sessionStorage.getItem('location_info'))
      if (cinfo.cid) {
        resolve(cinfo)
      }
    } else {
      getLocationInfoByApi(resolve)
    }
  })
}

async function getLocationInfoByApi(resolve) {
  const { data } = await api.getLocation()
  if (data.cid) {
    cinfo.cid = data.cid
    cinfo.cname = data.name
    if (data.cid !== '0') {
      sessionStorage.setItem('location_info', JSON.stringify(cinfo))
    }
  }
  resolve(cinfo)
}
